import { memo } from "react";

const AppArticlesIcon = ({ color = "#3069B2" }) => {
	return (
		<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M18.19 4.55102e-05H6.84C4.75 4.55102e-05 3.06 1.64078 3.06 3.66169V18.3383C3.1 18.7385 3.47 19.0386 3.89 18.9986C4.25 18.9686 4.54 18.6885 4.57 18.3383V3.66169C4.57 2.44115 5.59 1.4607 6.84 1.4607H18.19C19.44 1.4607 20.46 2.44115 20.46 3.66169V18.3383C20.46 19.5589 19.44 20.5393 18.19 20.5393H3.81C2.56 20.5393 1.54 19.5589 1.54 18.3383V3.66169C1.54 3.25151 1.2 2.91136 0.769997 2.91136C0.339997 2.91136 0 3.24151 0 3.66169V18.3383C0 20.3692 1.7 22.01 3.8 22C3.8 22 3.8 22 3.81 22H18.19C20.28 22.01 21.99 20.3792 22 18.3483C22 18.3483 22 18.3483 22 18.3383V3.66169C22 1.63078 20.3 -0.009959 18.2 4.55102e-05C18.2 4.55102e-05 18.2 4.55102e-05 18.19 4.55102e-05Z"
				fill={color}
			/>
			<path
				d="M18.1893 5.86202H6.83933C6.41933 5.90202 6.04934 5.60202 6.00934 5.20202C5.96934 4.80202 6.27934 4.44202 6.68934 4.40202C6.73934 4.40202 6.78933 4.40202 6.83933 4.40202H18.1893C18.6093 4.36202 18.9793 4.66202 19.0193 5.06202C19.0593 5.46202 18.7493 5.82202 18.3393 5.86202C18.2893 5.86202 18.2393 5.86202 18.1893 5.86202Z"
				fill={color}
			/>
			<path
				d="M18.1898 17.6174H6.83982C6.41982 17.5774 6.11983 17.2174 6.15983 16.8174C6.19983 16.4674 6.47982 16.1874 6.83982 16.1574H18.1898C18.6098 16.1174 18.9798 16.4174 19.0198 16.8174C19.0598 17.2174 18.7498 17.5774 18.3398 17.6174C18.2898 17.6174 18.2398 17.6174 18.1898 17.6174Z"
				fill={color}
			/>
			<path
				d="M18.1901 10.2739H13.6601C13.2401 10.2339 12.9401 9.87388 12.9801 9.47388C13.0201 9.12388 13.3001 8.84388 13.6601 8.81388H18.1901C18.6101 8.77388 18.9801 9.07388 19.0201 9.47388C19.0601 9.87388 18.7501 10.2339 18.3401 10.2739C18.2901 10.2739 18.2401 10.2739 18.1901 10.2739Z"
				fill={color}
			/>
			<path
				d="M18.1901 13.9458H13.6601C13.2401 13.9058 12.9401 13.5458 12.9801 13.1458C13.0201 12.7958 13.3001 12.5158 13.6601 12.4858H18.1901C18.6101 12.4458 18.9801 12.7458 19.0201 13.1458C19.0601 13.5458 18.7501 13.9058 18.3401 13.9458C18.2901 13.9458 18.2401 13.9458 18.1901 13.9458Z"
				fill={color}
			/>
			<path
				d="M10.6498 14.6767H7.59985C6.76985 14.6767 6.08984 14.0164 6.08984 13.2161V9.5444C6.08984 8.73403 6.76985 8.08374 7.59985 8.08374H10.6498C11.4798 8.08374 12.1599 8.74404 12.1599 9.5444V13.2161C12.1599 14.0264 11.4798 14.6767 10.6498 14.6767ZM7.58984 9.5444V13.2161H10.6398V9.5444H7.58984Z"
				fill={color}
			/>
		</svg>
	);
};

export default memo(AppArticlesIcon);
